import React from 'react';

const UsersConfigs = {
    routes: [
        {
            path: '/users',
            private: true,
            hasHeader: true,
            hasLayout: true,
            component: React.lazy(() => import('./UsersScreen')),
        },
    ],
};
export default UsersConfigs;
